import { GPTSummaryNameForm } from '@op/components/GPT/PromptModal/PromptForm/GPTSummaryName';
import { Button, Checkbox, Form } from 'tea-component';
import React from 'react';
import { useIntl } from 'umi';
import { DBO_U } from '@op/utils/format';

type ResultOutputForm = {
  name: string;
  setName: (value: string) => void;
  isSave: boolean;
  setIsSave: (value: boolean) => void;
  emailList: Array<string>;
  setEmailList: (value: Array<string>) => void;
  showEmailMessage: boolean;
  setShowEmailMessage: (value: boolean) => void;
  gameInfo: any;
};

export default function ResultsOutput({
  name,
  setName,
  isSave,
  setIsSave,
  emailList,
  setEmailList,
  setShowEmailMessage,
  showEmailMessage,
  gameInfo,
}: ResultOutputForm) {
  const { formatMessage } = useIntl();

  const handleGotoSummaryList = () => {

    const currentPage = name?.includes('Keyword') ? 'KeywordAnalysis' : 'URLAnalysis';

    let url = `/opinion/AIAnalysisHub/${currentPage}?tab=savedAnalysisList`;
    const gameid =
      history.location?.query?.gameid || gameInfo?.edition_unified_id;
    if (gameid) {
      url += `&gameid=${gameid}`;
    }
    DBO_U.open(url);
  };

  return (
    <Form.Item className="dbo-save-info-form" label={formatMessage({ id: 'Save Report-1' })}>
      <Checkbox value={isSave} onChange={(value) => setIsSave?.(value)}>
        <div className='save-options'>
          {formatMessage({ id: 'Save to {page}' }, {
            page: (
              <Button type="link" onClick={handleGotoSummaryList}>
                {formatMessage({ id: '[Saved Analysis List]' })}
              </Button>
            )
          })}
        </div>
      </Checkbox>
      {
        isSave && (
          <Form.Item className="dbo-save-info">
            <GPTSummaryNameForm
              name={name}
              setName={setName}
              needSummaryName={isSave}
              emailList={emailList}
              showEmailMessage={showEmailMessage}
              setShowEmailMessage={setShowEmailMessage}
              setEmailList={setEmailList}
            ></GPTSummaryNameForm>
          </Form.Item>
        )
      }
    </Form.Item>
  );
}
